import { render, staticRenderFns } from "./bannerForm.vue?vue&type=template&id=2b8dc770&scoped=true"
import script from "./bannerForm.vue?vue&type=script&lang=js"
export * from "./bannerForm.vue?vue&type=script&lang=js"
import style0 from "./bannerForm.vue?vue&type=style&index=0&id=2b8dc770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8dc770",
  null
  
)

export default component.exports